var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 1.414,
    clipRule: "evenodd",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Forma-1",
    fill: "#666",
    d: "M1470.01 161.636c.17-1.482 1.45-2.636 2.99-2.636 1.54 0 2.82 1.154 2.99 2.636h3.47c1.4 0 2.54 1.127 2.54 2.513v.129c0 1.059-.67 1.966-1.61 2.335v11.874c0 1.385-1.14 2.513-2.54 2.513h-9.7c-1.4 0-2.54-1.128-2.54-2.513v-11.874a2.519 2.519 0 01-1.61-2.335v-.129c0-1.385 1.14-2.513 2.54-2.513h3.47zm7.84 18.172c.74 0 1.34-.593 1.34-1.321v-11.695h-12.38v11.695c0 .728.6 1.321 1.34 1.321h9.7zm-4.85-1.524c.33 0 .6-.267.6-.596v-6.711a.599.599 0 00-1.2 0v6.711c0 .329.27.596.6.596zm3.23 0c.34 0 .61-.267.61-.596v-6.711a.601.601 0 00-.61-.596c-.33 0-.6.267-.6.596v6.711c0 .329.27.596.6.596zm-6.46 0c.33 0 .6-.267.6-.596v-6.711a.599.599 0 00-.6-.596c-.34 0-.61.267-.61.596v6.711c0 .329.27.596.61.596zm9.69-12.684a1.33 1.33 0 001.33-1.322v-.129c0-.728-.6-1.321-1.33-1.321h-12.92c-.73 0-1.33.593-1.33 1.321v.129c0 .729.6 1.322 1.33 1.322h12.92zm-4.69-3.964a1.797 1.797 0 00-1.77-1.444c-.88 0-1.61.622-1.77 1.444h3.54z",
    transform: "translate(-1461 -158)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.dbfc4a327aaffe175baee9e69d9fa76d.svg";
export { ForwardRef as ReactComponent };